import { matchPath } from "react-router";

export const ROUTES = {
  LOGIN: "/login",
  ORGANIZATIONS: "/organizations",
  CHATS: "chats",
  DIRECTORY: "directory",
  ALERT: "alert",
  PRIORITY: "priority",
  PATIENT: "patient",
  PRIVATE: "private",
  INTERNAL: "non_patient",
  MESSAGE: "message",
  BROADCAST: "broadcast",
};

// Routes that render RightPanel (message view)
export const MESSAGE_ROUTE_PATTERNS = [
  `${ROUTES.CHATS}/:groupType/:chatId/${ROUTES.MESSAGE}`,
  `${ROUTES.DIRECTORY}/:groupType/:chatId/${ROUTES.MESSAGE}`,
];

// Routes that render EmptyMessagePanelView (no chat selected)
export const SECTION_ROUTE_PATTERNS = [
  ROUTES.CHATS,
  `${ROUTES.CHATS}/:groupType`,
  ROUTES.DIRECTORY,
  ROUTES.ALERT,
  `${ROUTES.ALERT}/${ROUTES.PATIENT}`,
];

export const isValidSubRoute = (splat: string | undefined): boolean => {
  if (!splat) return true;
  const allPatterns = [...MESSAGE_ROUTE_PATTERNS, ...SECTION_ROUTE_PATTERNS];
  return allPatterns.some(pattern =>
    matchPath({ path: pattern, end: true }, "/" + splat),
  );
};

export enum MODAL_ROUTES {
  CHANGE_PASSWORD = "change-password",
  EXPORT_CHAT = "export-chat",
  USER_PROFILE = "user-profile",
  ADD_USER = "add-user",
  ADD_PATIENT = "add-patient",
  ORGANIZATION_MEDIA = "organization-media",
  CALENDAR = "calendar",
  CARE_MAP = "care-map",
  LAB_REQUISITIONS = "lab-requisitions",
  SYNC_QUEUE = "sync-queue",
  MORE = "more",
}

export enum QUERY_ROUTES {
  MODAL = "modal",
  ADDRESS = "address",
}
